export default "__VITE_ASSET__CyjfwAR3__"